(function () {
  // Skip if reduced motion preference
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function init() {
    const sections = document.querySelectorAll('.section');
    sections.forEach(function (section, index) {
      // Skip first section (above fold)
      if (index === 0) return;
      section.setAttribute('data-scroll-animate', '');
    });

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -48px 0px' }
    );

    document.querySelectorAll('[data-scroll-animate]').forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
